// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.search-match-tooltip {
  --rt-transition-closing-delay: 0s;
  z-index: 10001;
  pointer-events: none;
  max-width: min(340px, calc(100vw - 24px));
  padding: 10px 14px;
  text-align: start;
  font-size: 14px;
  line-height: 1.5;
}

.search-match-tooltip > span {
  display: block;
}

.search-match-select {
  width: 174px;
}

.search-match-control {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  flex-shrink: 0;
  gap: 2px;
  border-left: 1px solid #dce5e9;
  padding-left: 22px;
  margin-right: 12px;
}

.search-query-control {
  display: flex;
  flex: 1 1;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
  margin: 0 24px 0 32px;
  text-align: left;
}

.search-input-label,
.search-match-label {
  color: #526d7a;
  font-family: "Roboto", sans-serif;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.1em;
  line-height: 1.4;
  text-transform: uppercase;
  white-space: nowrap;
}

.search-bar-labeled .search-query-control .text-input,
.search-bar-labeled .search-query-control .arabic-text-input {
  color: #12394d;
  font-family: "Roboto", sans-serif;
  font-size: 24px;
  line-height: 1.35;
  padding: 0;
  width: 100%;
}

.search-query-control input::placeholder {
  color: #7b8790;
  opacity: 1;
}

.arabic-search-bar .search-input-label,
.arabic-search-bar .search-match-label {
  direction: rtl;
  letter-spacing: normal;
  font-size: 13px;
}

.arabic-search-bar .search-query-control {
  text-align: right;
}

.arabic-search-bar .search-match-control {
  align-items: flex-end;
}

.search-match-select .option-arrow,
.search-match-select .arabic-option-arrow {
  color: #427e93;
  height: 12px;
}

form.search-bar-labeled:focus-within {
  box-shadow: 0 0 0 2px #427e93;
}

.search-bar .text-input,
.arabic-search-bar .arabic-text-input {
  min-width: 0;
}

@media (max-width: 650px) {
  form.search-bar-labeled,
  .home-search-section form.search-bar-labeled {
    display: grid;
    grid-template-columns: minmax(0, 1fr) 48px;
    gap: 10px;
    height: auto;
    min-height: 140px;
    padding: 16px 20px;
    border-radius: 28px;
  }

  .search-query-control {
    grid-column: 1 / -1;
    grid-row: 1;
    margin: 0;
  }

  .search-bar-labeled .search-query-control .text-input,
  .search-bar-labeled .search-query-control .arabic-text-input {
    font-size: 20px;
  }

  .search-match-control {
    grid-column: 1;
    grid-row: 2;
    border-left: 0;
    padding-left: 0;
    margin-right: 0;
    min-width: 0;
  }

  .search-match-select {
    min-width: 0;
    width: min(174px, 100%);
  }

  .home-search-section .search-bar-labeled .search-submit-button,
  .home-search-section .search-bar-labeled .arabic-search-submit-button,
  .search-bar-labeled .search-submit-button,
  .search-bar-labeled .arabic-search-submit-button {
    grid-column: 2;
    grid-row: 2;
    height: 48px;
    width: 48px;
    margin: 0;
  }
}

.search-bar {
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  height: 78px;
  max-width: 1160px;
  width: 76%;
  border-top: 0;
  border-left: 0;
  border-right: 0;
  border-bottom: 2px solid #cccccc;
  border-radius: 42px;
  background-color: #ffffff;
  box-shadow: 0 2px 0 rgba(15, 23, 42, 0.08);
  margin-left: auto;
  margin-right: auto;
}

.home-search-section .search-bar {
  border-radius: 48px;
  height: 92px;
  max-width: 1320px;
  width: calc(100% - 56px);
}

@media (max-width: 900px) {
  .search-bar {
    width: 80%;
  }

  .home-search-section .search-bar {
    width: calc(100% - 56px);
  }
}
@media (max-width: 500px) {
  .search-bar {
    width: 95%;
  }

  .home-search-section .search-bar {
    border-radius: 48px;
    height: 92px;
    width: calc(100% - 32px);
  }
}
.text-input {
  background: transparent;
  flex: 1 1;
  border: none;
  padding: 5px 5px 5px 36px;
  font-family: "Roboto Bold", "Roboto", sans-serif;
  font-size: 28px;
  outline: none;
}

.home-search-section .text-input {
  font-size: 30px;
  padding-left: 40px;
}

.filter-styles-control {
  background-color: #ffffff;
  border: 1px solid #cccccc;
  border-radius: 36px;
  margin-right: 0.7em;
}

.filter-styles-placeholder {
  font-size: 1em;
  font-weight: 400;
}

.filter-styles-option {
  background-color: #e5e5e5;
  color: #ffffff;
}

.option-arrow {
  color: #cc0000;
  height: 16px;
}

.search-icon {
  align-items: center;
  justify-content: end;
  color: #cc0000;
  height: 24px;
  padding-right: 24px;
}

.home-search-section .search-icon {
  height: 30px;
  padding-right: 0;
  color: #ffffff;
}

.search-submit-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 0;
  background: transparent;
  padding: 0;
  cursor: pointer;
}

.home-search-section .search-submit-button {
  background: #cc0000;
  border-radius: 50%;
  flex: 0 0 64px;
  height: 64px;
  margin-right: 14px;
  width: 64px;
}

.home-search-section .search-submit-button:hover,
.home-search-section .search-submit-button:focus-visible {
  background: #a90000;
  outline: none;
}

.left-up-arrow {
  color: #808080;
  height: 12px;
  margin-right: 10px;
}

@media (max-width: 650px) {
  .left-up-arrow {
    display: none;
  }
}

.text-below-search-box-div {
  display: flex;
  color: #808080;
  font-size: 14px;
  line-height: 150%;
  height: 24px;
  font-family: "Roboto Bold", "Roboto", sans-serif;
  font-style: normal;
  font-weight: 400;
  justify-content: flex-start;
  margin-top: 5px;
}

@media (max-width: 1100px) {
  .text-below-search-box-div {
    margin-left: 40px;
  }
}

.search-div {
  display: flex;
  justify-content: center;
  text-align: center;
  margin-top: 60px;
}

/* Autocomplete */

.below-input {
  position: relative;
}

.autocomplete-div {
  position: absolute;
  z-index: 100;
  max-width: 980px;
  width: 68%;
  left: 50%;
  transform: translateX(-50%);
}

.home-search-section .autocomplete-div {
  max-width: 1320px;
  width: calc(100% - 56px);
}

@media (max-width: 900px) {
  .autocomplete-div {
    width: 80%;
  }

  .home-search-section .autocomplete-div {
    width: calc(100% - 56px);
  }
}

@media (max-width: 500px) {
  .autocomplete-div {
    width: 95%;
  }

  .home-search-section .autocomplete-div {
    width: calc(100% - 32px);
  }
}

.autocomplete-suggestions {
  list-style: none;
  margin: 0;
  padding: 0;
  background: white;
  position: absolute;
  z-index: 1000;
  width: 100%;
  border: 1px solid #cccccc;
  border-top: none;
  max-height: 300px;
  overflow-y: auto;
}

.suggestion-item {
  padding: 10px;
  border-bottom: 1px solid #cccccc;
  cursor: pointer;
}

.suggestion-item:hover {
  background-color: #f2f2f2;
}

/* Underbar (hint left, translate right) */
.search-underbar-row {
  display: flex;
  justify-content: center;
}

.search-underbar {
  max-width: 1160px;
  width: 76%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 22px;
  margin-top: 12px;
}

.home-search-section .search-underbar {
  max-width: 1320px;
  width: calc(100% - 56px);
}

@media (max-width: 900px) {
  .search-underbar {
    width: 80%;
  }

  .home-search-section .search-underbar {
    width: calc(100% - 56px);
  }
}

@media (max-width: 500px) {
  .search-underbar {
    width: 95%;
  }

  .home-search-section .search-underbar {
    width: calc(100% - 32px);
  }
}

.search-hint {
  display: inline-flex;
  align-items: center;
  background: #f8f9fc;
  border: 1px solid #e2e7ef;
  border-radius: 999px;
  box-shadow: 0 2px 0 rgba(15, 23, 42, 0.08);
  box-sizing: border-box;
  color: #667085;
  cursor: pointer;
  font-size: 22px;
  gap: 12px;
  line-height: 1;
  height: 64px;
  min-height: 64px;
  width: 260px;
  font-family: "Roboto Bold", "Roboto", sans-serif;
  font-style: normal;
  font-weight: 800;
  justify-content: center;
  padding: 0 24px;
  white-space: nowrap;
}

.search-hint-icon {
  color: #667085;
  height: 20px;
  width: 20px;
}

.search-hint p {
  margin: 0;
}

.search-hint:hover,
.search-hint:focus-visible {
  background: #eef7fa;
  border-color: #9dbac3;
  box-shadow: 0 4px 14px rgba(18, 57, 77, 0.14);
  color: #12394d;
  outline: none;
}

/* Translation Toggle */
.translation-toggle-row {
  display: flex;
  justify-content: center;
}

.translation-toggle-underbar {
  width: 50%;
  display: flex;
  justify-content: flex-end;
  margin-top: 6px;
}

@media (max-width: 900px) {
  .translation-toggle-underbar {
    width: 80%;
  }
}

@media (max-width: 500px) {
  .translation-toggle-underbar {
    width: 95%;
  }
}

.translation-toggle-label {
  align-items: center;
  background: #f8f9fc;
  border: 1px solid #e2e7ef;
  border-radius: 999px;
  box-shadow: 0 2px 0 rgba(15, 23, 42, 0.08);
  color: #667085;
  cursor: pointer;
  direction: ltr;
  display: inline-flex;
  flex-direction: row;
  font-family: "Roboto Bold", "Roboto", sans-serif;
  font-size: 22px;
  font-weight: 800;
  gap: 14px;
  min-height: 64px;
  min-width: 260px;
  padding: 0 24px;
  position: relative;
  -webkit-user-select: none;
          user-select: none;
}

.translation-toggle-label:hover {
  background: #eef7fa;
  border-color: #9dbac3;
  box-shadow: 0 4px 14px rgba(18, 57, 77, 0.14);
  color: #12394d;
}

.translation-toggle-label:focus-within {
  background: #eef7fa;
  border-color: #9dbac3;
  box-shadow: 0 4px 14px rgba(18, 57, 77, 0.14);
}

.translation-toggle-checkbox {
  cursor: pointer;
  height: 1px;
  margin: 0;
  opacity: 0;
  position: absolute;
  width: 1px;
}

.translation-toggle-icon {
  color: #667085;
  height: 22px;
  order: 1;
}

.translation-toggle-switch {
  background: #d5dbe5;
  border-radius: 999px;
  display: inline-flex;
  flex: 0 0 54px;
  height: 30px;
  order: 3;
  position: relative;
  transition: background-color 160ms ease;
}

.translation-toggle-switch::after {
  background: #ffffff;
  border-radius: 50%;
  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.2);
  content: "";
  height: 22px;
  left: 4px;
  position: absolute;
  top: 4px;
  transition: transform 160ms ease;
  width: 22px;
}

.translation-toggle-checkbox:checked ~ .translation-toggle-switch {
  background: #cc0000;
}

.translation-toggle-label:hover .translation-toggle-switch,
.translation-toggle-label:focus-within .translation-toggle-switch {
  background: #c5d2dc;
}

.translation-toggle-label:hover .translation-toggle-checkbox:checked ~ .translation-toggle-switch,
.translation-toggle-label:focus-within .translation-toggle-checkbox:checked ~ .translation-toggle-switch {
  background: #a90000;
}

.translation-toggle-checkbox:checked ~ .translation-toggle-switch::after {
  transform: translateX(24px);
}

.translation-toggle-checkbox:focus-visible ~ .translation-toggle-switch {
  outline: 3px solid rgba(66, 126, 147, 0.35);
  outline-offset: 3px;
}

.translation-toggle-text {
  color: #667085;
  font-size: inherit;
  order: 2;
}

.translation-toggle-label:hover .translation-toggle-icon,
.translation-toggle-label:hover .translation-toggle-text,
.translation-toggle-label:focus-within .translation-toggle-icon,
.translation-toggle-label:focus-within .translation-toggle-text {
  color: #12394d;
}

.translation-controls {
  align-items: center;
  display: flex;
  flex: 0 0 auto;
  gap: 12px;
}

.translation-toggle-label--compact {
  order: 2;
}

.search-language-row {
  display: flex;
  justify-content: center;
}

.translate-flow {
  display: flex;
  align-items: stretch;
  justify-content: center;
  gap: 16px;
  margin: 14px auto 0;
  width: -moz-fit-content;
  width: fit-content;
}

.translate-flow--underbar {
  align-items: stretch;
  flex: 0 0 270px;
  gap: 0;
  height: 60px;
  margin: 0;
  order: 1;
  position: relative;
}

.translate-flow-section {
  min-width: 0;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
}

.translate-flow-section--target {
  flex: 0 0 auto;
}

.translate-flow-label {
  font-family: "Roboto Bold", "Roboto", sans-serif;
  font-size: 12px;
  font-weight: 800;
  color: #4f626b;
  text-transform: uppercase;
}

.translate-flow--underbar .translate-flow-label {
  color: #5f727c;
  font-size: 13px;
  left: 50%;
  letter-spacing: 1px;
  line-height: 1;
  position: absolute;
  top: 11px;
  transform: translateX(-50%);
  white-space: nowrap;
  z-index: 1;
}

.translate-flow-arrow {
  align-self: center;
  color: #cc0000;
  height: 14px;
  margin-top: 17px;
}

.translate-flow-arrow--muted {
  color: #999999;
}

.translate-flow-target {
  min-height: 38px;
  display: inline-flex;
  align-items: center;
  border: 1px solid #cccccc;
  border-radius: 22px;
  padding: 0 14px;
  font-family: "Roboto Bold", "Roboto", sans-serif;
  font-size: 14px;
  color: #222222;
  background: #ffffff;
  white-space: nowrap;
}

.translate-flow-target--muted {
  color: #666666;
  background: #f7f7f7;
}

.lang-selector {
  position: relative;
}

.translate-flow--underbar .lang-selector {
  width: 100%;
}

.lang-selector-btn {
  min-height: 44px;
  display: inline-flex;
  align-items: center;
  gap: 10px;
  border: 1px solid #cccccc;
  border-radius: 22px;
  background: #ffffff;
  color: #222222;
  padding: 0 16px;
  font-family: "Roboto Bold", "Roboto", sans-serif;
  font-size: 15px;
  cursor: pointer;
}

.translate-flow--underbar .lang-selector-btn {
  align-items: center;
  background: #ffffff;
  border: 1px solid #cfd9de;
  border-radius: 999px;
  box-shadow: 0 10px 26px rgba(18, 57, 77, 0.12);
  color: #12394d;
  gap: 12px;
  height: 60px;
  min-height: 60px;
  padding: 12px 32px 8px 10px;
  position: relative;
  width: 100%;
}

.translate-flow--underbar .lang-selector-btn:hover {
  border-color: #9dbac3;
}

.lang-selector-btn--fixed {
  cursor: default;
  pointer-events: none;
}

.lang-selector-short,
.lang-option-short {
  min-width: 36px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
  padding: 4px 7px;
  background: #eeeeee;
  color: #333333;
  font-weight: 700;
  font-size: 12px;
}

.translate-flow--underbar .lang-selector-short {
  background: #cc0000;
  border-radius: 50%;
  color: #ffffff;
  font-size: 16px;
  height: 42px;
  min-width: 42px;
  padding: 0;
  width: 42px;
}

.lang-selector-label {
  white-space: nowrap;
}

.translate-flow--underbar .lang-selector-label {
  bottom: 10px;
  color: #12394d;
  font-size: 21px;
  font-weight: 800;
  left: 50%;
  line-height: 1;
  margin-top: 0;
  position: absolute;
  transform: translateX(-50%);
}

.lang-selector-caret {
  color: #cc0000;
  height: 12px;
}

.translate-flow--underbar .lang-selector-caret {
  color: #12394d;
  height: 12px;
  margin-left: auto;
}

.lang-dropdown {
  position: absolute;
  z-index: 1001;
  top: calc(100% + 8px);
  left: 0;
  min-width: 240px;
  margin: 0;
  padding: 8px;
  list-style: none;
  border: 1px solid #d7e1e5;
  border-radius: 24px;
  background: #ffffff;
  box-shadow: 0 14px 32px rgba(18, 57, 77, 0.16);
}

.lang-option {
  display: flex;
  align-items: center;
  gap: 12px;
  min-height: 42px;
  padding: 7px 12px;
  border-radius: 16px;
  font-family: "Roboto Bold", "Roboto", sans-serif;
  font-size: 15px;
  color: #12394d;
  cursor: pointer;
}

.lang-option:hover {
  background: #f3f7f8;
}

.lang-option--active {
  background: #eaf2f4;
  color: #12394d;
  font-weight: 800;
}

.lang-option-short {
  border: 2px solid transparent;
}

.lang-option--active .lang-option-short {
  background: #eeeeee;
  border-color: #427e93;
  color: #333333;
}

.lang-option-label {
  flex: 1 1;
}

.lang-option-check {
  color: #427e93;
  height: 13px;
  margin-left: auto;
}

@media (max-width: 900px) {
  .translate-flow {
    width: -moz-fit-content;
    width: fit-content;
  }
}

@media (max-width: 650px) {
  .search-underbar {
    flex-wrap: wrap;
    gap: 8px;
  }

  .search-hint {
    min-width: 0;
    white-space: normal;
  }

  .translate-flow {
    flex-wrap: wrap;
    max-width: 95%;
    width: 95%;
  }

  .translation-controls {
    align-items: stretch;
    flex: 1 1 100%;
    flex-direction: column;
    max-width: 95%;
    width: 95%;
  }

  .translation-toggle-label--compact {
    justify-content: center;
    min-width: 0;
    width: 100%;
  }

  .translate-flow-section {
    flex: 1 1 100%;
  }

  .translate-flow-arrow {
    display: none;
  }

  .lang-selector,
  .lang-selector-btn,
  .translate-flow-target {
    width: 100%;
  }

  .lang-dropdown {
    width: 100%;
  }

  .translate-flow--underbar {
    flex: 1 1 100%;
    height: 60px;
    max-width: 100%;
    width: 100%;
  }

  .translate-flow--underbar .translate-flow-label {
    font-size: 12px;
    left: 50%;
    top: 11px;
  }

  .translate-flow--underbar .lang-selector-btn {
    height: 60px;
    min-height: 60px;
    padding: 12px 32px 8px 10px;
  }

  .translate-flow--underbar .lang-selector-short {
    font-size: 16px;
    height: 42px;
    min-width: 42px;
    width: 42px;
  }

  .translate-flow--underbar .lang-selector-label {
    display: inline;
    font-size: 21px;
  }
}

@media (max-width: 500px) {
  .translate-flow {
    width: 95%;
  }

  .lang-selector-label {
    display: none;
  }
}

.translation-toggle-label:hover .translation-toggle-text {
  color: #12394d;
}
`, "",{"version":3,"sources":["webpack://./src/styles/search-input.css"],"names":[],"mappings":"AAAA;EACE,iCAAiC;EACjC,cAAc;EACd,oBAAoB;EACpB,yCAAyC;EACzC,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,cAAc;EACd,QAAQ;EACR,8BAA8B;EAC9B,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,SAAO;EACP,sBAAsB;EACtB,QAAQ;EACR,YAAY;EACZ,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;;EAEE,cAAc;EACd,iCAAiC;EACjC,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;;EAEE,cAAc;EACd,iCAAiC;EACjC,eAAe;EACf,iBAAiB;EACjB,UAAU;EACV,WAAW;AACb;;AAEA;EACE,cAAc;EACd,UAAU;AACZ;;AAEA;;EAEE,cAAc;EACd,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;;EAEE,cAAc;EACd,YAAY;AACd;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;;EAEE,YAAY;AACd;;AAEA;EACE;;IAEE,aAAa;IACb,0CAA0C;IAC1C,SAAS;IACT,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;IACnB,WAAW;IACX,SAAS;EACX;;EAEA;;IAEE,eAAe;EACjB;;EAEA;IACE,cAAc;IACd,WAAW;IACX,cAAc;IACd,eAAe;IACf,eAAe;IACf,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,uBAAuB;EACzB;;EAEA;;;;IAIE,cAAc;IACd,WAAW;IACX,YAAY;IACZ,WAAW;IACX,SAAS;EACX;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,UAAU;EACV,aAAa;EACb,cAAc;EACd,eAAe;EACf,gCAAgC;EAChC,mBAAmB;EACnB,yBAAyB;EACzB,0CAA0C;EAC1C,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA;EACE;IACE,UAAU;EACZ;;EAEA;IACE,wBAAwB;EAC1B;AACF;AACA;EACE;IACE,UAAU;EACZ;;EAEA;IACE,mBAAmB;IACnB,YAAY;IACZ,wBAAwB;EAC1B;AACF;AACA;EACE,uBAAuB;EACvB,SAAO;EACP,YAAY;EACZ,yBAAyB;EACzB,gDAAgD;EAChD,eAAe;EACf,aAAa;AACf;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,cAAc;EACd,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,uBAAuB;EACvB,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,WAAW;AACb;;AAEA;;EAEE,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE,aAAa;EACb,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,YAAY;EACZ,gDAAgD;EAChD,kBAAkB;EAClB,gBAAgB;EAChB,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,iBAAiB;;AAEjB;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA;EACE;IACE,UAAU;EACZ;;EAEA;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,UAAU;EACZ;;EAEA;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,yBAAyB;EACzB,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,0CAA0C;AAC1C;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA;EACE;IACE,UAAU;EACZ;;EAEA;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,UAAU;EACZ;;EAEA;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,oBAAoB;EACpB,0CAA0C;EAC1C,sBAAsB;EACtB,cAAc;EACd,eAAe;EACf,eAAe;EACf,SAAS;EACT,cAAc;EACd,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,gDAAgD;EAChD,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,SAAS;AACX;;AAEA;;EAEE,mBAAmB;EACnB,qBAAqB;EACrB,6CAA6C;EAC7C,cAAc;EACd,aAAa;AACf;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,UAAU;EACV,aAAa;EACb,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,UAAU;EACZ;AACF;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,oBAAoB;EACpB,0CAA0C;EAC1C,cAAc;EACd,eAAe;EACf,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,gDAAgD;EAChD,eAAe;EACf,gBAAgB;EAChB,SAAS;EACT,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,6CAA6C;EAC7C,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,eAAe;EACf,WAAW;EACX,SAAS;EACT,UAAU;EACV,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,QAAQ;AACV;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,oBAAoB;EACpB,cAAc;EACd,YAAY;EACZ,QAAQ;EACR,kBAAkB;EAClB,uCAAuC;AACzC;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,2CAA2C;EAC3C,WAAW;EACX,YAAY;EACZ,SAAS;EACT,kBAAkB;EAClB,QAAQ;EACR,gCAAgC;EAChC,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2CAA2C;EAC3C,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,QAAQ;AACV;;AAEA;;;;EAIE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,cAAc;EACd,SAAS;AACX;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,oBAAoB;EACpB,uBAAuB;EACvB,SAAS;EACT,mBAAmB;EACnB,uBAAkB;EAAlB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,MAAM;EACN,YAAY;EACZ,SAAS;EACT,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gDAAgD;EAChD,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,SAAS;EACT,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,SAAS;EACT,2BAA2B;EAC3B,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,gDAAgD;EAChD,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;EACT,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gDAAgD;EAChD,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,oBAAoB;EACpB,8CAA8C;EAC9C,cAAc;EACd,SAAS;EACT,YAAY;EACZ,gBAAgB;EAChB,2BAA2B;EAC3B,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,oBAAoB;AACtB;;AAEA;;EAEE,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,YAAY;EACZ,eAAe;EACf,UAAU;EACV,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,SAAS;EACT,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,YAAY;AACd;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,qBAAqB;EACrB,OAAO;EACP,gBAAgB;EAChB,SAAS;EACT,YAAY;EACZ,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,gDAAgD;EAChD,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE;IACE,uBAAkB;IAAlB,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,eAAe;IACf,QAAQ;EACV;;EAEA;IACE,YAAY;IACZ,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,cAAc;IACd,UAAU;EACZ;;EAEA;IACE,oBAAoB;IACpB,cAAc;IACd,sBAAsB;IACtB,cAAc;IACd,UAAU;EACZ;;EAEA;IACE,uBAAuB;IACvB,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,aAAa;EACf;;EAEA;;;IAGE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,cAAc;IACd,YAAY;IACZ,eAAe;IACf,WAAW;EACb;;EAEA;IACE,eAAe;IACf,SAAS;IACT,SAAS;EACX;;EAEA;IACE,YAAY;IACZ,gBAAgB;IAChB,2BAA2B;EAC7B;;EAEA;IACE,eAAe;IACf,YAAY;IACZ,eAAe;IACf,WAAW;EACb;;EAEA;IACE,eAAe;IACf,eAAe;EACjB;AACF;;AAEA;EACE;IACE,UAAU;EACZ;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE,cAAc;AAChB","sourcesContent":[".search-match-tooltip {\n  --rt-transition-closing-delay: 0s;\n  z-index: 10001;\n  pointer-events: none;\n  max-width: min(340px, calc(100vw - 24px));\n  padding: 10px 14px;\n  text-align: start;\n  font-size: 14px;\n  line-height: 1.5;\n}\n\n.search-match-tooltip > span {\n  display: block;\n}\n\n.search-match-select {\n  width: 174px;\n}\n\n.search-match-control {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  flex-shrink: 0;\n  gap: 2px;\n  border-left: 1px solid #dce5e9;\n  padding-left: 22px;\n  margin-right: 12px;\n}\n\n.search-query-control {\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n  gap: 2px;\n  min-width: 0;\n  margin: 0 24px 0 32px;\n  text-align: left;\n}\n\n.search-input-label,\n.search-match-label {\n  color: #526d7a;\n  font-family: \"Roboto\", sans-serif;\n  font-size: 11px;\n  font-weight: 600;\n  letter-spacing: 0.1em;\n  line-height: 1.4;\n  text-transform: uppercase;\n  white-space: nowrap;\n}\n\n.search-bar-labeled .search-query-control .text-input,\n.search-bar-labeled .search-query-control .arabic-text-input {\n  color: #12394d;\n  font-family: \"Roboto\", sans-serif;\n  font-size: 24px;\n  line-height: 1.35;\n  padding: 0;\n  width: 100%;\n}\n\n.search-query-control input::placeholder {\n  color: #7b8790;\n  opacity: 1;\n}\n\n.arabic-search-bar .search-input-label,\n.arabic-search-bar .search-match-label {\n  direction: rtl;\n  letter-spacing: normal;\n  font-size: 13px;\n}\n\n.arabic-search-bar .search-query-control {\n  text-align: right;\n}\n\n.arabic-search-bar .search-match-control {\n  align-items: flex-end;\n}\n\n.search-match-select .option-arrow,\n.search-match-select .arabic-option-arrow {\n  color: #427e93;\n  height: 12px;\n}\n\nform.search-bar-labeled:focus-within {\n  box-shadow: 0 0 0 2px #427e93;\n}\n\n.search-bar .text-input,\n.arabic-search-bar .arabic-text-input {\n  min-width: 0;\n}\n\n@media (max-width: 650px) {\n  form.search-bar-labeled,\n  .home-search-section form.search-bar-labeled {\n    display: grid;\n    grid-template-columns: minmax(0, 1fr) 48px;\n    gap: 10px;\n    height: auto;\n    min-height: 140px;\n    padding: 16px 20px;\n    border-radius: 28px;\n  }\n\n  .search-query-control {\n    grid-column: 1 / -1;\n    grid-row: 1;\n    margin: 0;\n  }\n\n  .search-bar-labeled .search-query-control .text-input,\n  .search-bar-labeled .search-query-control .arabic-text-input {\n    font-size: 20px;\n  }\n\n  .search-match-control {\n    grid-column: 1;\n    grid-row: 2;\n    border-left: 0;\n    padding-left: 0;\n    margin-right: 0;\n    min-width: 0;\n  }\n\n  .search-match-select {\n    min-width: 0;\n    width: min(174px, 100%);\n  }\n\n  .home-search-section .search-bar-labeled .search-submit-button,\n  .home-search-section .search-bar-labeled .arabic-search-submit-button,\n  .search-bar-labeled .search-submit-button,\n  .search-bar-labeled .arabic-search-submit-button {\n    grid-column: 2;\n    grid-row: 2;\n    height: 48px;\n    width: 48px;\n    margin: 0;\n  }\n}\n\n.search-bar {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n  height: 78px;\n  max-width: 1160px;\n  width: 76%;\n  border-top: 0;\n  border-left: 0;\n  border-right: 0;\n  border-bottom: 2px solid #cccccc;\n  border-radius: 42px;\n  background-color: #ffffff;\n  box-shadow: 0 2px 0 rgba(15, 23, 42, 0.08);\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.home-search-section .search-bar {\n  border-radius: 48px;\n  height: 92px;\n  max-width: 1320px;\n  width: calc(100% - 56px);\n}\n\n@media (max-width: 900px) {\n  .search-bar {\n    width: 80%;\n  }\n\n  .home-search-section .search-bar {\n    width: calc(100% - 56px);\n  }\n}\n@media (max-width: 500px) {\n  .search-bar {\n    width: 95%;\n  }\n\n  .home-search-section .search-bar {\n    border-radius: 48px;\n    height: 92px;\n    width: calc(100% - 32px);\n  }\n}\n.text-input {\n  background: transparent;\n  flex: 1;\n  border: none;\n  padding: 5px 5px 5px 36px;\n  font-family: \"Roboto Bold\", \"Roboto\", sans-serif;\n  font-size: 28px;\n  outline: none;\n}\n\n.home-search-section .text-input {\n  font-size: 30px;\n  padding-left: 40px;\n}\n\n.filter-styles-control {\n  background-color: #ffffff;\n  border: 1px solid #cccccc;\n  border-radius: 36px;\n  margin-right: 0.7em;\n}\n\n.filter-styles-placeholder {\n  font-size: 1em;\n  font-weight: 400;\n}\n\n.filter-styles-option {\n  background-color: #e5e5e5;\n  color: #ffffff;\n}\n\n.option-arrow {\n  color: #cc0000;\n  height: 16px;\n}\n\n.search-icon {\n  align-items: center;\n  justify-content: end;\n  color: #cc0000;\n  height: 24px;\n  padding-right: 24px;\n}\n\n.home-search-section .search-icon {\n  height: 30px;\n  padding-right: 0;\n  color: #ffffff;\n}\n\n.search-submit-button {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border: 0;\n  background: transparent;\n  padding: 0;\n  cursor: pointer;\n}\n\n.home-search-section .search-submit-button {\n  background: #cc0000;\n  border-radius: 50%;\n  flex: 0 0 64px;\n  height: 64px;\n  margin-right: 14px;\n  width: 64px;\n}\n\n.home-search-section .search-submit-button:hover,\n.home-search-section .search-submit-button:focus-visible {\n  background: #a90000;\n  outline: none;\n}\n\n.left-up-arrow {\n  color: #808080;\n  height: 12px;\n  margin-right: 10px;\n}\n\n@media (max-width: 650px) {\n  .left-up-arrow {\n    display: none;\n  }\n}\n\n.text-below-search-box-div {\n  display: flex;\n  color: #808080;\n  font-size: 14px;\n  line-height: 150%;\n  height: 24px;\n  font-family: \"Roboto Bold\", \"Roboto\", sans-serif;\n  font-style: normal;\n  font-weight: 400;\n  justify-content: flex-start;\n  margin-top: 5px;\n}\n\n@media (max-width: 1100px) {\n  .text-below-search-box-div {\n    margin-left: 40px;\n  }\n}\n\n.search-div {\n  display: flex;\n  justify-content: center;\n  text-align: center;\n  margin-top: 60px;\n}\n\n/* Autocomplete */\n\n.below-input {\n  position: relative;\n}\n\n.autocomplete-div {\n  position: absolute;\n  z-index: 100;\n  max-width: 980px;\n  width: 68%;\n  left: 50%;\n  transform: translateX(-50%);\n}\n\n.home-search-section .autocomplete-div {\n  max-width: 1320px;\n  width: calc(100% - 56px);\n}\n\n@media (max-width: 900px) {\n  .autocomplete-div {\n    width: 80%;\n  }\n\n  .home-search-section .autocomplete-div {\n    width: calc(100% - 56px);\n  }\n}\n\n@media (max-width: 500px) {\n  .autocomplete-div {\n    width: 95%;\n  }\n\n  .home-search-section .autocomplete-div {\n    width: calc(100% - 32px);\n  }\n}\n\n.autocomplete-suggestions {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  background: white;\n  position: absolute;\n  z-index: 1000;\n  width: 100%;\n  border: 1px solid #cccccc;\n  border-top: none;\n  max-height: 300px;\n  overflow-y: auto;\n}\n\n.suggestion-item {\n  padding: 10px;\n  border-bottom: 1px solid #cccccc;\n  cursor: pointer;\n}\n\n.suggestion-item:hover {\n  background-color: #f2f2f2;\n}\n\n/* Underbar (hint left, translate right) */\n.search-underbar-row {\n  display: flex;\n  justify-content: center;\n}\n\n.search-underbar {\n  max-width: 1160px;\n  width: 76%;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 22px;\n  margin-top: 12px;\n}\n\n.home-search-section .search-underbar {\n  max-width: 1320px;\n  width: calc(100% - 56px);\n}\n\n@media (max-width: 900px) {\n  .search-underbar {\n    width: 80%;\n  }\n\n  .home-search-section .search-underbar {\n    width: calc(100% - 56px);\n  }\n}\n\n@media (max-width: 500px) {\n  .search-underbar {\n    width: 95%;\n  }\n\n  .home-search-section .search-underbar {\n    width: calc(100% - 32px);\n  }\n}\n\n.search-hint {\n  display: inline-flex;\n  align-items: center;\n  background: #f8f9fc;\n  border: 1px solid #e2e7ef;\n  border-radius: 999px;\n  box-shadow: 0 2px 0 rgba(15, 23, 42, 0.08);\n  box-sizing: border-box;\n  color: #667085;\n  cursor: pointer;\n  font-size: 22px;\n  gap: 12px;\n  line-height: 1;\n  height: 64px;\n  min-height: 64px;\n  width: 260px;\n  font-family: \"Roboto Bold\", \"Roboto\", sans-serif;\n  font-style: normal;\n  font-weight: 800;\n  justify-content: center;\n  padding: 0 24px;\n  white-space: nowrap;\n}\n\n.search-hint-icon {\n  color: #667085;\n  height: 20px;\n  width: 20px;\n}\n\n.search-hint p {\n  margin: 0;\n}\n\n.search-hint:hover,\n.search-hint:focus-visible {\n  background: #eef7fa;\n  border-color: #9dbac3;\n  box-shadow: 0 4px 14px rgba(18, 57, 77, 0.14);\n  color: #12394d;\n  outline: none;\n}\n\n/* Translation Toggle */\n.translation-toggle-row {\n  display: flex;\n  justify-content: center;\n}\n\n.translation-toggle-underbar {\n  width: 50%;\n  display: flex;\n  justify-content: flex-end;\n  margin-top: 6px;\n}\n\n@media (max-width: 900px) {\n  .translation-toggle-underbar {\n    width: 80%;\n  }\n}\n\n@media (max-width: 500px) {\n  .translation-toggle-underbar {\n    width: 95%;\n  }\n}\n\n.translation-toggle-label {\n  align-items: center;\n  background: #f8f9fc;\n  border: 1px solid #e2e7ef;\n  border-radius: 999px;\n  box-shadow: 0 2px 0 rgba(15, 23, 42, 0.08);\n  color: #667085;\n  cursor: pointer;\n  direction: ltr;\n  display: inline-flex;\n  flex-direction: row;\n  font-family: \"Roboto Bold\", \"Roboto\", sans-serif;\n  font-size: 22px;\n  font-weight: 800;\n  gap: 14px;\n  min-height: 64px;\n  min-width: 260px;\n  padding: 0 24px;\n  position: relative;\n  user-select: none;\n}\n\n.translation-toggle-label:hover {\n  background: #eef7fa;\n  border-color: #9dbac3;\n  box-shadow: 0 4px 14px rgba(18, 57, 77, 0.14);\n  color: #12394d;\n}\n\n.translation-toggle-label:focus-within {\n  background: #eef7fa;\n  border-color: #9dbac3;\n  box-shadow: 0 4px 14px rgba(18, 57, 77, 0.14);\n}\n\n.translation-toggle-checkbox {\n  cursor: pointer;\n  height: 1px;\n  margin: 0;\n  opacity: 0;\n  position: absolute;\n  width: 1px;\n}\n\n.translation-toggle-icon {\n  color: #667085;\n  height: 22px;\n  order: 1;\n}\n\n.translation-toggle-switch {\n  background: #d5dbe5;\n  border-radius: 999px;\n  display: inline-flex;\n  flex: 0 0 54px;\n  height: 30px;\n  order: 3;\n  position: relative;\n  transition: background-color 160ms ease;\n}\n\n.translation-toggle-switch::after {\n  background: #ffffff;\n  border-radius: 50%;\n  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.2);\n  content: \"\";\n  height: 22px;\n  left: 4px;\n  position: absolute;\n  top: 4px;\n  transition: transform 160ms ease;\n  width: 22px;\n}\n\n.translation-toggle-checkbox:checked ~ .translation-toggle-switch {\n  background: #cc0000;\n}\n\n.translation-toggle-label:hover .translation-toggle-switch,\n.translation-toggle-label:focus-within .translation-toggle-switch {\n  background: #c5d2dc;\n}\n\n.translation-toggle-label:hover .translation-toggle-checkbox:checked ~ .translation-toggle-switch,\n.translation-toggle-label:focus-within .translation-toggle-checkbox:checked ~ .translation-toggle-switch {\n  background: #a90000;\n}\n\n.translation-toggle-checkbox:checked ~ .translation-toggle-switch::after {\n  transform: translateX(24px);\n}\n\n.translation-toggle-checkbox:focus-visible ~ .translation-toggle-switch {\n  outline: 3px solid rgba(66, 126, 147, 0.35);\n  outline-offset: 3px;\n}\n\n.translation-toggle-text {\n  color: #667085;\n  font-size: inherit;\n  order: 2;\n}\n\n.translation-toggle-label:hover .translation-toggle-icon,\n.translation-toggle-label:hover .translation-toggle-text,\n.translation-toggle-label:focus-within .translation-toggle-icon,\n.translation-toggle-label:focus-within .translation-toggle-text {\n  color: #12394d;\n}\n\n.translation-controls {\n  align-items: center;\n  display: flex;\n  flex: 0 0 auto;\n  gap: 12px;\n}\n\n.translation-toggle-label--compact {\n  order: 2;\n}\n\n.search-language-row {\n  display: flex;\n  justify-content: center;\n}\n\n.translate-flow {\n  display: flex;\n  align-items: stretch;\n  justify-content: center;\n  gap: 16px;\n  margin: 14px auto 0;\n  width: fit-content;\n}\n\n.translate-flow--underbar {\n  align-items: stretch;\n  flex: 0 0 270px;\n  gap: 0;\n  height: 60px;\n  margin: 0;\n  order: 1;\n  position: relative;\n}\n\n.translate-flow-section {\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 4px;\n}\n\n.translate-flow-section--target {\n  flex: 0 0 auto;\n}\n\n.translate-flow-label {\n  font-family: \"Roboto Bold\", \"Roboto\", sans-serif;\n  font-size: 12px;\n  font-weight: 800;\n  color: #4f626b;\n  text-transform: uppercase;\n}\n\n.translate-flow--underbar .translate-flow-label {\n  color: #5f727c;\n  font-size: 13px;\n  left: 50%;\n  letter-spacing: 1px;\n  line-height: 1;\n  position: absolute;\n  top: 11px;\n  transform: translateX(-50%);\n  white-space: nowrap;\n  z-index: 1;\n}\n\n.translate-flow-arrow {\n  align-self: center;\n  color: #cc0000;\n  height: 14px;\n  margin-top: 17px;\n}\n\n.translate-flow-arrow--muted {\n  color: #999999;\n}\n\n.translate-flow-target {\n  min-height: 38px;\n  display: inline-flex;\n  align-items: center;\n  border: 1px solid #cccccc;\n  border-radius: 22px;\n  padding: 0 14px;\n  font-family: \"Roboto Bold\", \"Roboto\", sans-serif;\n  font-size: 14px;\n  color: #222222;\n  background: #ffffff;\n  white-space: nowrap;\n}\n\n.translate-flow-target--muted {\n  color: #666666;\n  background: #f7f7f7;\n}\n\n.lang-selector {\n  position: relative;\n}\n\n.translate-flow--underbar .lang-selector {\n  width: 100%;\n}\n\n.lang-selector-btn {\n  min-height: 44px;\n  display: inline-flex;\n  align-items: center;\n  gap: 10px;\n  border: 1px solid #cccccc;\n  border-radius: 22px;\n  background: #ffffff;\n  color: #222222;\n  padding: 0 16px;\n  font-family: \"Roboto Bold\", \"Roboto\", sans-serif;\n  font-size: 15px;\n  cursor: pointer;\n}\n\n.translate-flow--underbar .lang-selector-btn {\n  align-items: center;\n  background: #ffffff;\n  border: 1px solid #cfd9de;\n  border-radius: 999px;\n  box-shadow: 0 10px 26px rgba(18, 57, 77, 0.12);\n  color: #12394d;\n  gap: 12px;\n  height: 60px;\n  min-height: 60px;\n  padding: 12px 32px 8px 10px;\n  position: relative;\n  width: 100%;\n}\n\n.translate-flow--underbar .lang-selector-btn:hover {\n  border-color: #9dbac3;\n}\n\n.lang-selector-btn--fixed {\n  cursor: default;\n  pointer-events: none;\n}\n\n.lang-selector-short,\n.lang-option-short {\n  min-width: 36px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 6px;\n  padding: 4px 7px;\n  background: #eeeeee;\n  color: #333333;\n  font-weight: 700;\n  font-size: 12px;\n}\n\n.translate-flow--underbar .lang-selector-short {\n  background: #cc0000;\n  border-radius: 50%;\n  color: #ffffff;\n  font-size: 16px;\n  height: 42px;\n  min-width: 42px;\n  padding: 0;\n  width: 42px;\n}\n\n.lang-selector-label {\n  white-space: nowrap;\n}\n\n.translate-flow--underbar .lang-selector-label {\n  bottom: 10px;\n  color: #12394d;\n  font-size: 21px;\n  font-weight: 800;\n  left: 50%;\n  line-height: 1;\n  margin-top: 0;\n  position: absolute;\n  transform: translateX(-50%);\n}\n\n.lang-selector-caret {\n  color: #cc0000;\n  height: 12px;\n}\n\n.translate-flow--underbar .lang-selector-caret {\n  color: #12394d;\n  height: 12px;\n  margin-left: auto;\n}\n\n.lang-dropdown {\n  position: absolute;\n  z-index: 1001;\n  top: calc(100% + 8px);\n  left: 0;\n  min-width: 240px;\n  margin: 0;\n  padding: 8px;\n  list-style: none;\n  border: 1px solid #d7e1e5;\n  border-radius: 24px;\n  background: #ffffff;\n  box-shadow: 0 14px 32px rgba(18, 57, 77, 0.16);\n}\n\n.lang-option {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  min-height: 42px;\n  padding: 7px 12px;\n  border-radius: 16px;\n  font-family: \"Roboto Bold\", \"Roboto\", sans-serif;\n  font-size: 15px;\n  color: #12394d;\n  cursor: pointer;\n}\n\n.lang-option:hover {\n  background: #f3f7f8;\n}\n\n.lang-option--active {\n  background: #eaf2f4;\n  color: #12394d;\n  font-weight: 800;\n}\n\n.lang-option-short {\n  border: 2px solid transparent;\n}\n\n.lang-option--active .lang-option-short {\n  background: #eeeeee;\n  border-color: #427e93;\n  color: #333333;\n}\n\n.lang-option-label {\n  flex: 1;\n}\n\n.lang-option-check {\n  color: #427e93;\n  height: 13px;\n  margin-left: auto;\n}\n\n@media (max-width: 900px) {\n  .translate-flow {\n    width: fit-content;\n  }\n}\n\n@media (max-width: 650px) {\n  .search-underbar {\n    flex-wrap: wrap;\n    gap: 8px;\n  }\n\n  .search-hint {\n    min-width: 0;\n    white-space: normal;\n  }\n\n  .translate-flow {\n    flex-wrap: wrap;\n    max-width: 95%;\n    width: 95%;\n  }\n\n  .translation-controls {\n    align-items: stretch;\n    flex: 1 1 100%;\n    flex-direction: column;\n    max-width: 95%;\n    width: 95%;\n  }\n\n  .translation-toggle-label--compact {\n    justify-content: center;\n    min-width: 0;\n    width: 100%;\n  }\n\n  .translate-flow-section {\n    flex: 1 1 100%;\n  }\n\n  .translate-flow-arrow {\n    display: none;\n  }\n\n  .lang-selector,\n  .lang-selector-btn,\n  .translate-flow-target {\n    width: 100%;\n  }\n\n  .lang-dropdown {\n    width: 100%;\n  }\n\n  .translate-flow--underbar {\n    flex: 1 1 100%;\n    height: 60px;\n    max-width: 100%;\n    width: 100%;\n  }\n\n  .translate-flow--underbar .translate-flow-label {\n    font-size: 12px;\n    left: 50%;\n    top: 11px;\n  }\n\n  .translate-flow--underbar .lang-selector-btn {\n    height: 60px;\n    min-height: 60px;\n    padding: 12px 32px 8px 10px;\n  }\n\n  .translate-flow--underbar .lang-selector-short {\n    font-size: 16px;\n    height: 42px;\n    min-width: 42px;\n    width: 42px;\n  }\n\n  .translate-flow--underbar .lang-selector-label {\n    display: inline;\n    font-size: 21px;\n  }\n}\n\n@media (max-width: 500px) {\n  .translate-flow {\n    width: 95%;\n  }\n\n  .lang-selector-label {\n    display: none;\n  }\n}\n\n.translation-toggle-label:hover .translation-toggle-text {\n  color: #12394d;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
